import { render, staticRenderFns } from "./jmsTXJY_BCContract.vue?vue&type=template&id=5b3a1d30"
import script from "./jmsTXJY_BCContract.vue?vue&type=script&lang=js"
export * from "./jmsTXJY_BCContract.vue?vue&type=script&lang=js"
import style0 from "./jmsTXJY_BCContract.vue?vue&type=style&index=0&id=5b3a1d30&prod&lang=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports